import React, { useRef, useEffect } from 'react';
import { Cropper } from 'react-advanced-cropper';
import 'react-advanced-cropper/dist/style.css';
import '../styles/crop.css';

const AdvancedImageCropper = ({ image, onCropComplete }) => {
  const cropperRef = useRef(null);

  useEffect(() => {
    return () => {
      if (image) {
        URL.revokeObjectURL(image);
      }
    };
  }, [image]);

  const handleCrop = () => {
    const cropper = cropperRef.current;
    if (cropper) {
      const canvas = cropper.getCanvas();
      if (canvas) {
        const dataUrl = canvas.toDataURL();
        onCropComplete(dataUrl);
      }
    }
  };

  return (
    <div className="cropper-container">
      <div className="cropper-wrapper">
        <Cropper
            ref={cropperRef}
            src={image}
            className="custom-cropper"
            backgroundClassName="custom-background"
            stencilProps={{ movable: true, resizable: true }} // allow freeform cropping
          />
      </div>
      <div className="buttons-wrapper mt-3">
        <button className="btn btn-success" onClick={handleCrop}>
          Confirm Crop
        </button>
      </div>
    </div>
  );
};

export default AdvancedImageCropper;
